import type { OrderStatus } from '@cracked-mug/shared';
import { ORDER_STATUS_LABELS } from '@cracked-mug/shared';
import { Check } from 'lucide-react';
import { cn } from '../../lib/cn';

const PIPELINE: OrderStatus[] = ['pending', 'accepted', 'preparing', 'ready', 'completed'];

export function StatusTracker({ status }: { status: OrderStatus }) {
  if (status === 'cancelled') {
    return (
      <div className="bg-wca-surface rounded-card shadow-card p-6 text-center">
        <p className="font-display text-2xl text-wca-red">Cancelled</p>
        <p className="text-sm text-wca-gray-mid mt-2">This order was cancelled.</p>
      </div>
    );
  }

  const currentIndex = PIPELINE.indexOf(status);

  return (
    <div className="bg-wca-surface rounded-card shadow-card p-5">
      <ol className="space-y-3">
        {PIPELINE.map((stage, i) => {
          const done = i < currentIndex;
          const current = i === currentIndex;
          return (
            <li key={stage} className="flex items-center gap-3">
              <div
                className={cn(
                  'w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold',
                  done && 'bg-wca-red text-white',
                  current && 'bg-wca-red text-white ring-4 ring-wca-red-light',
                  !done && !current && 'bg-wca-gray-light text-wca-gray-mid',
                )}
              >
                {done ? <Check size={14} aria-hidden="true" /> : i + 1}
              </div>
              <span
                className={cn(
                  'font-medium',
                  current && 'text-wca-red',
                  !done && !current && 'text-wca-gray-mid',
                )}
              >
                {ORDER_STATUS_LABELS[stage]}
              </span>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
